export type MovieType = 'movie' | 'tv' | 'variety';

export interface Movie {
  id: string;
  title: string;
  type: MovieType;
  year: number;
  region: string;
  genres: string[];
  poster: string;
  backdrop?: string;
  rating: number;
  views: number;
  director: string;
  cast: string[];
  synopsis: string;
  updateTime: string;
  featured?: boolean;
}

export const movies: Movie[] = [
  {
    id: 'mv-01',
    title: '星海征途',
    type: 'movie',
    year: 2025,
    region: '内地',
    genres: ['科幻', '冒险'],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20movie%20poster%20illustration%2C%20deep%20space%20nebula%20and%20lone%20astronaut%2C%20teal%20and%20dark%20green%20tones%2C%20dramatic%20rim%20light%2C%20minimal%20composition%2C%20no%20text&width=400&height=600&seq=sgv-m01&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20film%20still%2C%20vast%20starfield%20with%20distant%20planet%20and%20spaceship%2C%20teal%20and%20dark%20green%20palette%2C%20cinematic%20lighting%2C%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=sgv-h01&orientation=landscape',
    rating: 8.7,
    views: 9860,
    director: '陈昊宇',
    cast: ['李承泽', '苏晚清', '周牧之'],
    synopsis: '近未来，人类文明将希望寄托于一次跨越星系的远征。年轻宇航员林澈随“星海号”出发，寻找传说中的宜居星球。途中，队员之间的信念不断碰撞，一场意外让整艘飞船偏离既定航线，他们必须在无垠星海中重新定义“家园”。',
    updateTime: '2025-10-08',
    featured: true,
  },
  {
    id: 'mv-02',
    title: '长夜将明',
    type: 'movie',
    year: 2024,
    region: '内地',
    genres: ['悬疑', '犯罪'],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20neo-noir%20poster%20illustration%2C%20rain-soaked%20city%20alley%20at%20night%2C%20moody%20green%20and%20amber%20light%2C%20silhouette%20of%20detective%2C%20minimal%2C%20no%20text&width=400&height=600&seq=sgv-m02&orientation=portrait',
    rating: 8.2,
    views: 7420,
    director: '许知远',
    cast: ['方励', '韩清', '林一舟'],
    synopsis: '一桩尘封十年的旧案重新浮出水面。退休刑警陆沉被请回警队协助调查，线索却将他一步步引向自己不愿面对的过去。真相与谎言在漫漫长夜中交织，直到黎明来临前的一刻。',
    updateTime: '2025-09-30',
  },
  {
    id: 'mv-03',
    title: '夏日来信',
    type: 'movie',
    year: 2024,
    region: '日本',
    genres: ['爱情', '剧情'],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20romantic%20drama%20poster%20illustration%2C%20sunlit%20seaside%20town%2C%20soft%20pastel%20sky%2C%20two%20figures%20on%20a%20pier%2C%20warm%20nostalgic%20tones%2C%20minimal%2C%20no%20text&width=400&height=600&seq=sgv-m03&orientation=portrait',
    rating: 7.9,
    views: 6180,
    director: '小林苍',
    cast: ['樱井遥', '松本凌', '桥本奈'],
    synopsis: '海边小镇的夏天，一封迟到多年的信让两个曾经错过的人重新相遇。他们沿着旧日的足迹走走停停，在潮起潮落之间，慢慢读懂了当年那句没有说出口的话。',
    updateTime: '2025-09-22',
  },
  {
    id: 'mv-04',
    title: '龙脊山',
    type: 'movie',
    year: 2025,
    region: '内地',
    genres: ['动作', '武侠'],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20wuxia%20action%20poster%20illustration%2C%20misty%20mountain%20ridge%20at%20dawn%2C%20lone%20swordsman%20silhouette%2C%20ink%20wash%20style%2C%20green%20and%20gold%2C%20no%20text&width=400&height=600&seq=sgv-m04&orientation=portrait',
    rating: 7.5,
    views: 5240,
    director: '赵无极',
    cast: ['程飞', '叶霜', '罗烈'],
    synopsis: '江湖传言龙脊山上藏着一本失传的剑谱。少年剑客为寻父仇踏上此山，却在巅峰之上遇见了守山多年的神秘老人。一场关于剑、关于义、关于放下执念的对决就此展开。',
    updateTime: '2025-09-18',
  },
  {
    id: 'mv-05',
    title: '城市脉搏',
    type: 'tv',
    year: 2025,
    region: '内地',
    genres: ['都市', '情感'],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20urban%20drama%20poster%20illustration%2C%20modern%20city%20skyline%20at%20dusk%2C%20glowing%20windows%2C%20muted%20teal%20and%20warm%20amber%2C%20minimal%2C%20no%20text&width=400&height=600&seq=sgv-m05&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20city%20drama%20still%2C%20modern%20skyline%20at%20dusk%20with%20glowing%20windows%2C%20muted%20teal%20and%20amber%20lighting%2C%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=sgv-h06&orientation=landscape',
    rating: 8.0,
    views: 8930,
    director: '高远',
    cast: ['秦朗', '沈知夏', '白露'],
    synopsis: '在一座永远不眠的城市里，四个不同行业的年轻人因一次偶然的深夜相遇走到一起。他们在职场与生活之间寻找平衡，用各自的方式感受着这座城市跳动的脉搏。',
    updateTime: '2025-10-05',
    featured: true,
  },
  {
    id: 'mv-06',
    title: '暗涌',
    type: 'tv',
    year: 2024,
    region: '内地',
    genres: ['悬疑', '谍战'],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20spy%20thriller%20poster%20illustration%2C%20shadowy%20stairwell%2C%20single%20shaft%20of%20light%2C%20tense%20atmosphere%2C%20dark%20green%20tones%2C%20minimal%2C%20no%20text&width=400&height=600&seq=sgv-m06&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20spy%20thriller%20film%20still%2C%20rain%20night%20city%20rooftop%2C%20dramatic%20moody%20green%20light%2C%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=sgv-h02&orientation=landscape',
    rating: 8.5,
    views: 10240,
    director: '梁正',
    cast: ['傅寒', '齐悦', '谢铭'],
    synopsis: '1940年代的都市暗流汹涌，代号“青藤”的情报人员潜伏多年。当身份即将暴露，他必须在信仰与情义之间做出抉择，一场惊心动魄的暗战就此拉开序幕。',
    updateTime: '2025-10-01',
    featured: true,
  },
  {
    id: 'mv-07',
    title: '归途列车',
    type: 'tv',
    year: 2025,
    region: '内地',
    genres: ['家庭', '剧情'],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20family%20drama%20poster%20illustration%2C%20countryside%20train%20at%20golden%20hour%2C%20warm%20sunset%20fields%2C%20nostalgic%2C%20soft%20tones%2C%20minimal%2C%20no%20text&width=400&height=600&seq=sgv-m07&orientation=portrait',
    rating: 8.1,
    views: 5560,
    director: '孟川',
    cast: ['王建国', '刘慧芳', '陈思'],
    synopsis: '每到春节，连接小城与大都市的绿皮火车上，都挤满了归乡的人。一个普通家庭三代人的故事，在这条熟悉的铁路上缓缓展开，讲述着关于团圆、离别与守候的平凡感动。',
    updateTime: '2025-09-28',
  },
  {
    id: 'mv-08',
    title: '权谋之巅',
    type: 'tv',
    year: 2024,
    region: '美国',
    genres: ['剧情', '历史'],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20historical%20drama%20poster%20illustration%2C%20grand%20candlelit%20hall%2C%20ornate%20throne%20silhouette%2C%20rich%20amber%20and%20deep%20green%2C%20epic%2C%20no%20text&width=400&height=600&seq=sgv-m08&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20historical%20drama%20still%2C%20grand%20candlelit%20hall%20with%20throne%2C%20epic%20wide%20shot%2C%20amber%20and%20deep%20green%2C%20no%20text&width=1600&height=900&seq=sgv-h05&orientation=landscape',
    rating: 9.0,
    views: 11380,
    director: 'Ava Mitchell',
    cast: ['Edward Hale', 'Grace Monroe', 'Leo Grant'],
    synopsis: '一部横跨数十年的史诗剧集。一个家族在时代的洪流中起落沉浮，权力、忠诚与背叛在宫廷高墙内反复上演，而真正掌握命运的人，往往站在最不起眼的位置。',
    updateTime: '2025-09-25',
    featured: true,
  },
  {
    id: 'mv-09',
    title: '奇思妙想局',
    type: 'variety',
    year: 2025,
    region: '内地',
    genres: ['真人秀'],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20variety%20show%20poster%20illustration%2C%20colorful%20playful%20studio%20stage%2C%20geometric%20props%2C%20bright%20cheerful%20tones%2C%20minimal%2C%20no%20text&width=400&height=600&seq=sgv-m09&orientation=portrait',
    rating: 8.3,
    views: 7640,
    director: '陆川',
    cast: ['主持人安宁', '嘉宾团'],
    synopsis: '每期邀请不同领域的嘉宾，用天马行空的创意解决一个真实的难题。这里没有标准答案，只有不断碰撞的奇思妙想，让观众在欢笑中收获灵感。',
    updateTime: '2025-10-06',
  },
  {
    id: 'mv-10',
    title: '味道人间',
    type: 'variety',
    year: 2024,
    region: '内地',
    genres: ['美食', '纪实'],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20food%20documentary%20poster%20illustration%2C%20rustic%20table%20with%20steaming%20dishes%2C%20warm%20amber%20light%2C%20cozy%20kitchen%2C%20minimal%2C%20no%20text&width=400&height=600&seq=sgv-m10&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20food%20documentary%20still%2C%20rustic%20table%20with%20steaming%20dishes%20warm%20amber%20light%2C%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=sgv-h03&orientation=landscape',
    rating: 8.8,
    views: 9210,
    director: '周晓峰',
    cast: ['纪录片团队'],
    synopsis: '走进中国大大小小的街巷与厨房，记录一道道家常菜背后的人与情。食物是味道，更是记忆与牵挂，每一口都藏着一段关于故乡的故事。',
    updateTime: '2025-09-20',
    featured: true,
  },
  {
    id: 'mv-11',
    title: '声浪巅峰',
    type: 'variety',
    year: 2025,
    region: '内地',
    genres: ['音乐', '竞演'],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20music%20show%20poster%20illustration%2C%20concert%20stage%20with%20spotlights%2C%20silhouettes%20of%20singers%2C%20vibrant%20warm%20and%20green%20lights%2C%20no%20text&width=400&height=600&seq=sgv-m11&orientation=portrait',
    rating: 7.8,
    views: 6830,
    director: '何嘉',
    cast: ['导师阵容', '歌手团'],
    synopsis: '来自不同风格的歌手同台竞演，用声音点燃整个舞台。每一次改编都是一场冒险，每一次合唱都可能成为经典，谁能站上声浪巅峰？',
    updateTime: '2025-10-02',
  },
  {
    id: 'mv-12',
    title: '荒野求生记',
    type: 'variety',
    year: 2024,
    region: '内地',
    genres: ['户外', '冒险'],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20outdoor%20adventure%20poster%20illustration%2C%20vast%20mountain%20valley%2C%20lone%20hiker%20on%20cliff%20edge%2C%20dramatic%20sky%2C%20earthy%20tones%2C%20no%20text&width=400&height=600&seq=sgv-m12&orientation=portrait',
    rating: 8.2,
    views: 5480,
    director: '林野',
    cast: ['探险小队'],
    synopsis: '六位嘉宾被投放到无人之境，仅凭有限的工具完成生存挑战。他们将学会搭帐篷、辨方向、找水源，也会在极限环境下重新认识彼此与自己。',
    updateTime: '2025-09-16',
  },
  {
    id: 'mv-13',
    title: '回声谷',
    type: 'movie',
    year: 2023,
    region: '韩国',
    genres: ['惊悚', '悬疑'],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20psychological%20thriller%20poster%20illustration%2C%20foggy%20pine%20forest%2C%20faint%20figure%20between%20trees%2C%20eerie%20cold%20light%20with%20green%20cast%2C%20no%20text&width=400&height=600&seq=sgv-m13&orientation=portrait',
    rating: 7.7,
    views: 4620,
    director: '金敏哲',
    cast: ['朴英浩', '郑秀妍', '姜道允'],
    synopsis: '一个偏远山村每到夜晚都会传来莫名的回声。记者为调查一桩失踪案来到这里，却发现村民们都在刻意回避某个秘密，而回声背后隐藏着她无法想象的真相。',
    updateTime: '2025-09-12',
  },
  {
    id: 'mv-14',
    title: '云端之上',
    type: 'movie',
    year: 2025,
    region: '内地',
    genres: ['剧情', '励志'],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20inspirational%20drama%20poster%20illustration%2C%20lone%20figure%20on%20rooftop%20above%20clouds%20at%20sunrise%2C%20hopeful%20warm%20light%2C%20minimal%2C%20no%20text&width=400&height=600&seq=sgv-m14&orientation=portrait',
    rating: 8.4,
    views: 7120,
    director: '文章',
    cast: ['段誉', '邵静', '何伟'],
    synopsis: '一个普通的外卖骑手，怀揣着成为建筑师的梦想。白天穿梭于城市街巷，夜晚在图纸前反复描摹。当机会终于来临，他必须在现实与理想之间，做出属于自己的选择。',
    updateTime: '2025-09-10',
  },
  {
    id: 'mv-15',
    title: '深海之光',
    type: 'movie',
    year: 2024,
    region: '内地',
    genres: ['动画', '奇幻'],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20animated%20fantasy%20poster%20illustration%2C%20glowing%20underwater%20world%20with%20bioluminescent%20creatures%2C%20magical%20teal%20and%20gold%2C%20no%20text&width=400&height=600&seq=sgv-m15&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20animated%20underwater%20world%20still%2C%20glowing%20bioluminescent%20reef%2C%20magical%20teal%20and%20gold%2C%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=sgv-h04&orientation=landscape',
    rating: 8.6,
    views: 8940,
    director: '钱多多',
    cast: ['配音：小海', '珊珊', '老龟'],
    synopsis: '海底深处，一只小海豚为寻找失踪的家人踏上了旅程。它穿过发光的珊瑚森林，遇见了形形色色的海洋伙伴，也在旅途终点的黑暗里，发现了照亮一切的那束光。',
    updateTime: '2025-09-14',
    featured: true,
  },
  {
    id: 'mv-16',
    title: '医者仁心',
    type: 'tv',
    year: 2025,
    region: '内地',
    genres: ['医疗', '剧情'],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20medical%20drama%20poster%20illustration%2C%20hospital%20corridor%20with%20soft%20light%2C%20silhouetted%20doctor%2C%20calm%20clean%20tones%2C%20minimal%2C%20no%20text&width=400&height=600&seq=sgv-m16&orientation=portrait',
    rating: 8.3,
    views: 6420,
    director: '孙皓',
    cast: ['吴刚', '秦岚', '张译'],
    synopsis: '在一家三甲医院的急诊科里，医生们每天都在与时间赛跑。面对疑难杂症与人生百态，他们用专业与温度守护每一个生命，也在一次次抉择中理解了“仁心”的分量。',
    updateTime: '2025-10-04',
  },
  {
    id: 'mv-17',
    title: '风暴前夜',
    type: 'tv',
    year: 2024,
    region: '英国',
    genres: ['剧情', '政治'],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20political%20thriller%20poster%20illustration%2C%20dark%20parliament%20chamber%2C%20dramatic%20shadows%2C%20muted%20green%20and%20grey%2C%20minimal%2C%20no%20text&width=400&height=600&seq=sgv-m17&orientation=portrait',
    rating: 8.9,
    views: 9580,
    director: 'James Whitmore',
    cast: ['Oliver Reed', 'Sophia Kane', 'Daniel Price'],
    synopsis: '一场足以改变国家走向的危机正在逼近。资深幕僚、年轻记者与野心勃勃的政客各怀心思，在风暴来临前的倒计时里，没有人知道明天的新闻头条会写下谁的名字。',
    updateTime: '2025-09-26',
  },
  {
    id: 'mv-18',
    title: '青春二十岁',
    type: 'tv',
    year: 2025,
    region: '内地',
    genres: ['青春', '校园'],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20youth%20drama%20poster%20illustration%2C%20sunlit%20school%20courtyard%2C%20students%20walking%2C%20bright%20airy%20pastel%20tones%2C%20minimal%2C%20no%20text&width=400&height=600&seq=sgv-m18&orientation=portrait',
    rating: 7.6,
    views: 5980,
    director: '许晴',
    cast: ['周也', '陈飞宇', '李庚希'],
    synopsis: '大学宿舍里的四个女孩，在二十岁这一年经历了告白、分别、迷茫与成长。她们约定无论将来走到哪里，都要记得这段最耀眼的、允许犯错也允许做梦的时光。',
    updateTime: '2025-10-03',
  },
  {
    id: 'mv-19',
    title: '妙想实验室',
    type: 'variety',
    year: 2025,
    region: '内地',
    genres: ['科普', '实验'],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20science%20show%20poster%20illustration%2C%20colorful%20lab%20with%20glassware%20and%20glowing%20experiments%2C%20playful%20bright%20tones%2C%20no%20text&width=400&height=600&seq=sgv-m19&orientation=portrait',
    rating: 8.0,
    views: 4720,
    director: '方同',
    cast: ['科普团队'],
    synopsis: '用有趣又安全的实验，把藏在生活中的科学原理讲得明明白白。每一次动手都是一次发现，让大小朋友都能感受到科学的魅力与乐趣。',
    updateTime: '2025-09-19',
  },
  {
    id: 'mv-20',
    title: '环岛日记',
    type: 'variety',
    year: 2024,
    region: '内地',
    genres: ['旅行'],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20travel%20variety%20poster%20illustration%2C%20coastal%20island%20road%20with%20scooter%2C%20blue%20sea%20and%20green%20hills%2C%20sunny%20airy%20tones%2C%20no%20text&width=400&height=600&seq=sgv-m20&orientation=portrait',
    rating: 8.5,
    views: 7760,
    director: '杨帆',
    cast: ['旅行团'],
    synopsis: '沿着海岸线骑行一整圈，把沿途的风景、美食与故事都装进日记。没有紧凑的行程，只有放慢脚步后才看得见的、属于旅途本身的浪漫。',
    updateTime: '2025-09-24',
  },
];